var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentNode } from './content-node';
import { CellLabel } from '../elements/cell-label';
import { useLang } from '../hooks/use-lang';
import { useView } from '../hooks/use-view';
import { EntityAsideMenu, entityAsideMenuKey } from './entity-aside-menu';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('entity-conversations-aside-layout');
export var EntityConversationsAsideLayoutDefaultProps = {
  mainView: 'explorer'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(6))
});
var PaddingStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4))
});
var IntroStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    font-size: ", ";\n    padding-top: ", ";\n    color: ", ";\n  "], ["\n    ", ";\n    font-size: ", ";\n    padding-top: ", ";\n    color: ", ";\n  "])), PaddingStyles, theme.FONT_SIZE(14), theme.UNIT(2), theme.COLOR('text'))
});
var ConversationsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n    padding-bottom: ", ";\n  "], ["\n    ", ";\n    color: ", ";\n    padding-bottom: ", ";\n  "])), PaddingStyles, theme.COLOR('text-mid'), theme.UNIT(4))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityConversationssAsideLayout',
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Intro: styled(ContentNode)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Conversations: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ConversationsStyles),
  Label: styled(CellLabel)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Menu: styled(EntityAsideMenu)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles)
};
export var EntityConversationsAsideLayout = function (props) {
  var _a = useComponentProps(My.NAME, props, EntityConversationsAsideLayoutDefaultProps),
    className = _a.className,
    children = _a.children,
    items = _a.items,
    mainView = _a.mainView,
    intro = _a.intro;
  var t = useLang();
  var initialSubView = entityAsideMenuKey(items === null || items === void 0 ? void 0 : items[0]);
  var _b = useView(mainView, 'conversations', initialSubView),
    setActiveSubView = _b.setActiveSubView,
    activeSubView = _b.activeSubView;
  var handleEntityClick = function (entity) {
    setActiveSubView(entityAsideMenuKey(entity));
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Intro, {
    entity: intro
  }), React.createElement(My.Conversations, null, React.createElement(My.Label, null, t('Conversations:')), React.createElement(My.Menu, {
    onItemClick: handleEntityClick,
    activeItemKey: activeSubView,
    items: items
  })), children);
};
EntityConversationsAsideLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;